import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { FadeUp } from "@/components/landing/Reveal";
import { Wordmark } from "@/components/Logo";

const STEPS = [
  ["Responde", "Sí, No o N/A en cada reactivo, bloque por bloque."],
  ["Documenta", "Sube la foto de evidencia en cada incumplimiento."],
  ["Diagnostica", "Obtén tu % de cumplimiento y nivel de riesgo."],
  ["Corrige", "Descarga el PDF y agenda a un consultor Ascentra."],
];

export const RiskCTA = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <>
      <section id="riesgo" className="mx-auto max-w-[1400px] px-5 sm:px-8 py-24 lg:py-32 border-t border-white/10" data-testid="process-section">
        <FadeUp className="font-mono text-xs uppercase tracking-[0.22em] text-[#F59E0B]">/ 03 — Proceso</FadeUp>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {STEPS.map(([t, d], i) => (
            <FadeUp key={t} delay={i * 0.08} className="bg-[#0B0F17] p-8 min-h-[230px] flex flex-col justify-between group hover:bg-[#111722] transition-colors" data-testid={`process-step-${i + 1}`}>
              <span className="font-display-x text-6xl font-black text-[#F5F1E8]/10 group-hover:text-[#F59E0B] transition-colors">0{i + 1}</span>
              <div>
                <h3 className="font-display text-2xl font-bold">{t}</h3>
                <p className="mt-2 text-sm text-[#F5F1E8]/70">{d}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </section>

      <section ref={ref} className="relative overflow-hidden min-h-[80vh] flex items-end" data-testid="cta-section">
        <motion.div style={{ y }} className="absolute inset-[-12%_0]">
          <img src="/img/p4.jpg" alt="Operario con equipo de protección en maquinaria" className="w-full h-full object-cover grayscale" />
        </motion.div>
        <div className="absolute inset-0 bg-[#0B0F17]/75" />
        <div className="relative mx-auto max-w-[1400px] w-full px-5 sm:px-8 py-20 lg:py-28">
          <FadeUp>
            <h2 className="font-display-x text-[11vw] sm:text-7xl lg:text-[7rem] font-black uppercase leading-[0.88] tracking-[-0.03em]">
              ¿Qué tan<br />expuesta está<br /><span className="text-[#F59E0B]">tu planta?</span>
            </h2>
          </FadeUp>
          <FadeUp delay={0.15} className="mt-10 flex flex-col sm:flex-row sm:items-center gap-6">
            <Link to="/registro" data-testid="cta-start-audit-button" className="group inline-flex w-fit items-center gap-3 bg-[#F5F1E8] text-[#0B0F17] pl-7 pr-2 py-2 rounded-full font-semibold hover:bg-[#F59E0B] transition-colors">
              Descubrirlo en 10 minutos
              <span className="grid place-items-center w-10 h-10 rounded-full bg-[#0B0F17] text-[#F5F1E8] transition-transform duration-500 group-hover:rotate-45"><ArrowUpRight className="w-4 h-4" /></span>
            </Link>
            <p className="max-w-sm text-sm text-[#F5F1E8]/80">Diagnóstico gratuito. Tus respuestas y evidencias quedan protegidas en tu cuenta.</p>
          </FadeUp>
        </div>
      </section>

      <footer className="border-t border-white/10" data-testid="footer">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-12 flex flex-col md:flex-row gap-8 md:items-center justify-between">
          <Wordmark />
          <p className="font-mono text-xs text-[#F5F1E8]/60">Vigía es una herramienta de autodiagnóstico de Ascentra Consulting. No sustituye una inspección oficial de la STPS.</p>
          <p className="font-mono text-xs text-[#F5F1E8]/60">© {new Date().getFullYear()} Ascentra Consulting</p>
        </div>
      </footer>
    </>
  );
};
